import type { QueryClient } from "@tanstack/react-query"
import type { UserMeResponse } from "@/container/admin/hooks/users/Queries/useFetchUserMe"
import type { UserMeAddress } from "@/container/admin/hooks/users/Queries/useFetchUserMeAddress"
import { DataService } from "@/lib/dataService"

export async function fetchUserDataForRedirect(queryClient: QueryClient): Promise<{
  userMe: UserMeResponse | null
  userAddress: UserMeAddress | null
}> {
  try {
    const [userMe, userAddress] = await Promise.all([
      queryClient.fetchQuery({
        queryKey: ["USER_ME"],
        queryFn: async () => {
          const response = await DataService.get("/autenticacao/usuario-logado")
          return { ...response?.data, isAuthenticated: true } as UserMeResponse
        },
      }),
      queryClient.fetchQuery({
        queryKey: ["USERME_ADDRESS"],
        queryFn: async () => {
          const response = await DataService.get<UserMeAddress>("/membros/endereco/usuario-logado")
          return response?.data
        },
      }).catch(() => null),
    ])

    return { userMe, userAddress }
  } catch {
    return { userMe: null, userAddress: null }
  }
}

export function canAccessCarteira(userMe: UserMeResponse | null, userAddress: UserMeAddress | null): boolean {
  if (!userMe) return false

  if (!userMe.fl_membro) return false
  if (!userMe.cargo_oficial || userMe.cargo_oficial.status !== "aprovado") return false

  const requiredUserFields = [
    userMe.pais,
    userMe.nome,
    userMe.numero_documento,
    userMe.email,
    userMe.telefone,
    userMe.data_nascimento,
    userMe.sexo,
  ]

  const hasAllUserFields = requiredUserFields.every((field) => field && field.length > 0)

  if (!hasAllUserFields || !userAddress) return false

  const requiredAddressFields = [
    userAddress.codigo_postal,
    userAddress.estado,
    userAddress.cidade,
    userAddress.bairro,
    userAddress.logradouro,
    userAddress.numero,
  ]

  return requiredAddressFields.every((field) => field !== null && field !== undefined && String(field).length > 0)
}
